// Reward Configuration — single source of truth for all coin and EXP values.
// Change numbers here only — no other file needs to be touched for value adjustments.

// Coin rewards
export const COINS_PER_UNITY_GAME = 15 // flat coins awarded for completing any Unity game
export const MAX_COINS_PER_GAME = 15 // maximum coins a scored minigame can award
export const MIN_COINS_FOR_ATTEMPT = 5 // minimum coins awarded even for a zero score
export const COINS_PER_MISSION_COMPLETE = 20 // bonus coins for completing a full mission (first time only)

// EXP rewards
export const EXP_BASE_PER_MINIGAME = 25 // base EXP awarded for any minigame completion
export const EXP_MAX_BONUS_PER_MINIGAME = 30 // additional EXP awarded at 100% score (scales with score)
export const EXP_PER_UNITY_GAME = 25 // flat EXP for any Unity game
export const EXP_PER_MISSION_COMPLETE = 100 // bonus EXP for completing a full mission (first time only)

// Level thresholds — 12 levels total.
// Each entry = minimum cumulative EXP required to reach that level.
// To adjust difficulty: change the numbers. To add levels: append more entries.
export const LEVEL_THRESHOLDS = [
  { level: 1, minExp: 0, label: 'Rookie' },
  { level: 2, minExp: 200, label: 'Explorer' },
  { level: 3, minExp: 500, label: 'Seeker' },
  { level: 4, minExp: 900, label: 'Guardian' },
  { level: 5, minExp: 1400, label: 'Defender' },
  { level: 6, minExp: 2000, label: 'Ranger' },
  { level: 7, minExp: 2700, label: 'Champion' },
  { level: 8, minExp: 3500, label: 'Veteran' },
  { level: 9, minExp: 4400, label: 'Elite' },
  { level: 10, minExp: 5400, label: 'Master' },
  { level: 11, minExp: 6500, label: 'Legend' },
  { level: 12, minExp: 7700, label: 'Digipalz' }
]

export const MAX_LEVEL = 12

// Game type identifiers — used by the hook and service to determine reward logic
export const GAME_TYPES = {
  UNITY: 'unity', // flat coins + flat EXP
  SCORED: 'scored', // coins and EXP scaled to score percentage
  COMPLETION: 'completion' // flat coins + flat EXP (same as unity, for React games with no score)
}

// Maps each minigame ID to its type and max score.
// For UNITY/COMPLETION types, maxScore is ignored.
// For SCORED types, maxScore is the denominator used to calculate scorePercent.
export const MINIGAME_SCORE_CONFIG = {
  animalZoo: { gameType: GAME_TYPES.UNITY, maxScore: null },
  carRace: { gameType: GAME_TYPES.UNITY, maxScore: null },
  pacman: { gameType: GAME_TYPES.UNITY, maxScore: null },
  passwordInspector: { gameType: GAME_TYPES.UNITY, maxScore: null },
  digitalFootprint: { gameType: GAME_TYPES.UNITY, maxScore: null },
  ipAddress: { gameType: GAME_TYPES.UNITY, maxScore: null },
  mfa: { gameType: GAME_TYPES.UNITY, maxScore: null },
  howYouReact: { gameType: GAME_TYPES.SCORED, maxScore: 4 },
  outSmart: { gameType: GAME_TYPES.UNITY, maxScore: null },
  ghostHunt: { gameType: GAME_TYPES.COMPLETION, maxScore: null },
  chatModerator: { gameType: GAME_TYPES.SCORED, maxScore: null }, // maxScore = questions.length (dynamic)
  symptomSorter: { gameType: GAME_TYPES.SCORED, maxScore: null }, // maxScore = dynamic
  consentGame: { gameType: GAME_TYPES.SCORED, maxScore: 100 },
  flipCard: { gameType: GAME_TYPES.SCORED, maxScore: 1000 } // matches FLIP_CARD_MAX_SCORE in flip_card/constants/cardData.js
}
